/*
* @描述: 写跟进
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-11 14:48:55
*/
<template>
    <el-dialog :before-close="handleDialogClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               class="custom_form_dialog custom-form-dialog"
               title="写跟进"
               width="560px">
        <div v-loading="loading" class="custom_form_body">
            <CustomFormPc v-if="formInfoList.length"
                          ref="crm_custom_form"
                          :field_list="formInfoList"
                          :relate_customer_id="customer_id"
                          @submit-form="submitData"/>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import CustomFormPc from "@/components/pComponents/CustomFormPc";
    import {getFormFields, customerPrivateFollowUpAdd} from "@/api";

    export default {
        name: "followUpAdd",
        data() {
            return {
                formInfoList: [],
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            project_id: {
                type: Number,
                default: 0
            },
            customer_id: {
                type: Number,
                default: 0
            },
        },
        components: {CustomFormPc},
        created() {
            this._getFromFields()
        },
        methods: {
            _getFromFields() {
                this.loading = true
                getFormFields({
                    field_form: 'customer_follow_ups'
                }).then(res => {
                    if (res.code === 200) {
                        this.formInfoList = res.data
                    } else {

                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            },

            // 关闭弹窗
            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
            },

            // 确定
            handleDialogConfirm() {
                this.$refs.crm_custom_form.handleClickPublish()
            },

            submitData(data) {
                customerPrivateFollowUpAdd({
                    ...data,
                    project_id: this.project_id,
                    customer_id: '',
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('添加成功！')
                        this.$emit('refresh')
                        this.handleDialogClose()
                    } else {

                    }
                })
            },
        },
    }
</script>
<style lang="scss" scoped>
    .custom_form_body {
        height: 490px;
        padding: 24px;

        .page_little_title {
            margin-top: 16px;
        }
    }
</style>